module.exports = __webpack_public_path__ + "img/Download.519d92b0.png";